import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13 16h-7a2 2 0 0 1 -2 -2v-4a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v1","key":"svg-0"}],["path",{"d":"M16 18h6","key":"svg-1"}],["path",{"d":"M19 15v6","key":"svg-2"}]]

const IconCodeVariablePlus = createReactComponent('outline', 'code-variable-plus', 'CodeVariablePlus', __iconNode);

export default IconCodeVariablePlus;